import { firebaseContext } from 'components/MainComponent/FirebasContext'
import { child, onValue, runTransaction } from 'firebase/database'
import { useContext, useEffect, useState } from 'react'
import { useCustomEvent } from 'react-custom-events-hooks'

const localStorageKey = 'kaffeerechner2026'
declare global {
  interface Window {
    MFDATA: dbDataType
  }
}
window.MFDATA = {} as dbDataType
const readLocalStorage = () => {
  let data = localStorage.getItem(localStorageKey)
  return localStorage && data && JSON.parse(data)
}

function splitToChunks(array: any[], parts: number) {
  let result = []
  for (let i = parts; i > 0; i--) {
    result.push(array.splice(0, Math.ceil(array.length / i)))
  }
  return result
}
function calculateVoterStats(
  byCaffeine?: { [key: string]: number },
  byPortionCount?: { [key: string]: number }
) {
  if (!byCaffeine || !byPortionCount) return
  let sum = Object.values(byPortionCount).reduce((a, b) => a + +b, 0)
  if (sum === 0) return

  let caffeineEntries = Object.entries(byCaffeine).map((m) => +m[0] * m[1])
  let caffeineAverage = +(
    caffeineEntries.reduce((a, b) => a + +b, 0) / sum
  ).toFixed(1)

  let potSum = Object.values(byPortionCount).reduce((a, b) => a + +b, 0)
  let potCountEntries = Object.entries(byPortionCount).map((m) => +m[0] * m[1])
  let potCountAverage = +(
    potCountEntries.reduce((a, b) => a + +b, 0) / potSum
  ).toFixed(1)

  let abstinent = byPortionCount['0'] ? byPortionCount['0'] : 0

  let singlevalues = Object.entries(byCaffeine)
    .filter((f) => +f[0] <= 700)
    .map((m) => [...Array(m[1])].map((a) => +m[0]))
    .flat()
    .sort((a, b) => a - b)

  let thirdsChunks = splitToChunks(singlevalues, 3)

  let thirdsAverages = thirdsChunks.map((m) => {
    let sum = m.reduce((a, b) => a + b, 0)
    return sum / m.length
  })

  let thirdsMedian = thirdsChunks.map((m) => {
    let middle = Math.floor(m.length / 2)
    let nums = [...m].sort((a, b) => a - b)
    return m.length % 2 !== 0
      ? nums[middle]
      : (nums[middle - 1] + nums[middle]) / 2
  })

  let thirdsRange = thirdsChunks.map((m) => [Math.min(...m), Math.max(...m)])

  let thirdsRangeString = thirdsRange.map((m) => `${m[0]}|${m[1]}`)
  let barchartdata = Object.entries(byCaffeine)
    .reverse()
    .map((m) => {
      return {
        label: +m[0],
        value: m[1],
      }
    })

  return {
    sum,
    potCountAverage,
    caffeineAverage,
    abstinent,
    barchartdata,
    thirds: {
      ranges: thirdsRange,
      rangesString: thirdsRangeString,
      average: thirdsAverages,
      median: thirdsMedian,
    },
  }
}

export const ReadDataFromDbAndAddItToWindow = () => {
  const firebaseGlobals = useContext(firebaseContext)
  const [dbdata, setDbData] = useState<dbDataType>()
  const [localStorageData, setLocalStorageData] = useState<UserInputsType>()
  const writtenToWindow = useCustomEvent({
    eventName: 'wroteDataToWindow',
  })

  useEffect(() => {
    if (!dbdata && !localStorageData) return

    // LOCAL STORAGE
    let userParticpation = window.MFDATA
      ? window.MFDATA.userHasParticipated
      : false
    if (localStorageData) {
      userParticpation = true
    } else {
    }

    // DB DATA
    if (dbdata) {
      const voteStatsCalced = calculateVoterStats(
        dbdata.bycaffeine,
        dbdata.byportioncount
      )

      window.MFDATA = {
        ...dbdata,
        userHasParticipated: userParticpation,
        userinputs: localStorageData || window.MFDATA?.userinputs || {},
        voteStats: voteStatsCalced || {},
      }
      writtenToWindow({})
    }
  }, [dbdata, localStorageData])

  async function readDataFromFirebase() {

    try {
      onValue(
        firebaseGlobals.dbRef, 
        (snapshot) => {
          let data: dbDataType = snapshot.exists() ? snapshot.val() : {} as dbDataType;
          setDbData(data);
        },
        (error) => {
          console.error('Error in onValue callback:', error);
        }
      );
    } catch (e) {
      console.log('error reading data from firebase', e)
      console.error(e)
    }
  }

  useEffect(() => {
    let  dataFromLocalStorage = readLocalStorage()
    if (dataFromLocalStorage) {
      setLocalStorageData(dataFromLocalStorage)
    }
    readDataFromFirebase()
  }, [])


  return null
}

export const ReadDataFromWindow = ({
  callback,
}: {
  callback?: (e: any) => void
}) => {
  function eventReceived() {
    if (callback && window.MFDATA) callback(window.MFDATA)
  }

  useCustomEvent({
    eventName: 'wroteDataToWindow',
    onSignal: (e) => eventReceived(),
  })

  return null
}
